import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'

import {useI18n} from "vue-i18n"; // 引入插件中的方法
// const { t } = useI18n(); // 解构 t 方法
// import i18n from 'locales'
import i18n from '@/locales/index'

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "home",
        meta: {
            title: 'AdSeasy',
        },
        component: () => import('@/views/index.vue'),
        children: [
            {
                path: "/",
                name: "home",
                meta: {title: 'menu.home'},
                component: () => import('@/views/home/index.vue')
            },
            {
                path: "/user/",
                name: "user",
                meta: {title: 'header.Settings'},
                component: () => import('@/views/user/index.vue')
            },
            {
                path: "/found/apply",
                name: "foundApply",
                meta: {title: 'menu.foundApply'},
                component: () => import('@/views/found/apply.vue')
            },
            {
                path: "/found/Facebook",
                name: "foundFacebook",
                meta: {title: 'menu.foundFacebook'},
                component: () => import('@/views/found/Facebook.vue')
            },
            {
                path: "/found/tiktok",
                name: "foundTikTok",
                meta: {title: 'menu.foundTikTok'},
                component: () => import('@/views/found/tiktok.vue')
            },
            {
                path: "/found/tiktok/batch",
                name: "foundTikTokBatch",
                meta: {title: 'menu.foundTikTokBatch'},
                component: () => import('@/views/found/tiktokBatch.vue')
            },
            {
                path: "/found/kwai",
                name: "foundKwai",
                meta: {title: 'menu.foundKwai'},
                component: () => import('@/views/found/kwai.vue')
            },
            {
                path: "/found/google",
                name: "foundGoogle",
                meta: {title: 'menu.foundGoogle'},
                component: () => import('@/views/found/google.vue')
            },
            {
                path: "/account/rechargeone",
                name: "rechargeone",
                meta: {title: 'menu.rechargeone'},
                component: () => import('@/views/account/rechargeone.vue')
            },
            {
                path: "/account/rechargefour",
                name: "rechargefour",
                meta: {title: 'menu.rechargefour'},
                component: () => import('@/views/account/rechargefour.vue')
            },
            {
                path: "/account/rechargetwo",
                name: "rechargetwo",
                meta: {title: 'menu.rechargeone'},
                component: () => import('@/views/account/rechargetwo.vue')
            },
            {
                path: "/account/rechargethree",
                name: "rechargethree",
                meta: {title: 'menu.rechargethree'},
                component: () => import('@/views/account/rechargethree.vue')
            },
            {
                path: "/account/list",
                name: "accountList",
                meta: {title: 'menu.accountList'},
                component: () => import('@/views/account/list.vue')
            },
            {
                path: "/subAccount/list",
                name: "subAccountList",
                meta: {title: 'menu.subAccountList'},
                component: () => import('@/views/subaccount/list.vue')
            },
            {
                path: "/subClient/list",
                name: "subClientList",
                meta: {title: 'menu.subClientList'},
                component: () => import('@/views/subclient/list.vue')
            }, {
                path: "/partners/list",
                name: "Partners",
                meta: {title: 'menu.partnersList'},
                component: () => import('@/views/partners/list.vue')
            },
            {
                path: "/subClientAdvertiser/list",
                name: "subClientAdvertiserList",
                meta: {title: 'menu.subClientAdvertiserList'},
                component: () => import('@/views/subclientadvertiser/list.vue')
            },
            {
                path: "/account/record",
                name: "accountRecord",
                meta: {title: 'menu.accountRecord'},
                component: () => import('@/views/account/record.vue')
            },
            {
                path: "/check/monthSettlement",
                name: "monthSettlement",
                meta: {title: 'menu.monthSettlement'},
                component: () => import('@/views/check/monthSettlement.vue')
            },
            {
                path: "/subClientAccount/record",
                name: "subClientAccountRecord",
                meta: {title: 'menu.subClientAccountRecord'},
                component: () => import('@/views/subclientaccount/record.vue')
            },
            {
                path: "/account/details",
                name: "accountDetails",
                meta: {title: 'menu.accountDetails'},
                component: () => import('@/views/account/details.vue')
            },
            {
                path: "/subaccount/details",
                name: "subaccountDetails",
                meta: {title: 'menu.subaccountDetails'},
                component: () => import('@/views/subaccount/details.vue')
            },
            {
                path: "/agentsubaccount/details",
                name: "agentsubaccountDetails",
                meta: {title: 'menu.agentsubaccountDetails'},
                component: () => import('@/views/agentsubaccount/details.vue')
            },
            {
                path: "/subclient/details",
                name: "subclientDetails",
                meta: {title: 'menu.subclientDetails'},
                component: () => import('@/views/subclient/details.vue')
            },
            {
                path: "/subclient/accountlist",
                name: "subclientAccountlist",
                meta: {title: 'menu.subclientAccountlist'},
                component: () => import('@/views/subclient/accountlist.vue')
            },
            {
                path: "/account/recharge",
                name: "accountRecharge",
                meta: {title: 'menu.accountRecharge'},
                component: () => import('@/views/account/recharge.vue')
            },
            {
                path: "/account/monitor",
                name: "accountMonitor",
                meta: {title: 'menu.accountMonitor'},
                component: () => import('@/views/account/monitor.vue')
            },
            {
                path: "/account/monitorEr",
                name: "accountMonitorEr",
                meta: {title: 'menu.accountMonitor'},
                component: () => import('@/views/account/monitorEr.vue')
            },
            {
                path: "/check/wallet",
                name: "checkWallet",
                meta: {title: 'menu.walletRechargeRecord'},
                component: () => import('@/views/check/wallet.vue')
            },
            {
                path: "/media/auth",
                name: "mediaAuth",
                meta: {title: 'menu.mediaAuth'},
                component: () => import('@/views/media/auth.vue')
            },
            {
                path: "/subClientCheck/wallet",
                name: "subClientCheckWallet",
                meta: {title: 'menu.subClientWalletRecord'},
                component: () => import('@/views/subClientCheck/wallet.vue')
            },
            {
                path: "/advertisement/list",
                name: "advertisementList",
                meta: {title: 'menu.advertisementList'},
                component: () => import('@/views/advertisement/list.vue')
            },
            {
                path: "/check/balance",
                name: "checkBalance",
                meta: {title: 'menu.walletBalanceRecord'},
                component: () => import('@/views/check/balance.vue')
            },
            {
                path: "/check/advertiserTransaction",
                name: "advertiserTransaction",
                meta: {title: 'menu.advertiserTransaction'},
                component: () => import('@/views/check/advertiserTransaction.vue')
            },
            {
                path: "/check/advertiserTransfer",
                name: "advertiserTransfer",
                meta: {title: 'menu.advertiserTransfer'},
                component: () => import('@/views/check/advertiserTransfer.vue')
            },

            {
                path: "/notice/lists",
                name: "noticeLists",
                meta: {title: 'menu.noticeLists'},
                component: () => import('@/views/notice/list.vue')
            },
            {
                path: "/check/creditBalance",
                name: "checkCreditBalance",
                meta: {title: 'menu.creditBalanceRecord'},
                component: () => import('@/views/check/creditBalance.vue')
            },
            {
                path: "/subaccount/sublog",
                name: "subLog",
                meta: {title: 'menu.subLog'},
                component: () => import('@/views/subaccount/sublog.vue')
            }, {
                path: "/check/consume",
                name: "checkConsume",
                meta: {title: 'menu.CheckConsume'},
                component: () => import('@/views/check/consume.vue')
            },
            {
                path: "/guide",
                name: "guide",
                meta: {title: 'menu.guide'},
                component: () => import('@/views/guide/index.vue')
            },
            {
                path: "/help",
                name: "help",
                meta: {title: 'menu.helpCenter'},
                component: () => import('@/views/help/list.vue')
            },
            {
                path: "/partner",
                name: "partner",
                meta: {title: 'menu.partner'},
                 component: () => import('@/views/partners/list.vue')
            },
            {
                path: "/help/detail",
                name: "helpDetail",
                meta: {title: 'menu.helpDetail'},
                component: () => import('@/views/help/details.vue')
            }
        ]
    },
    {
        path: "/auth/login",
        name: "login",
        meta: {title: 'menu.login'},
        component: () => import('@/views/auth/login.vue')
    },
    {
        path: "/auth/password",
        name: "password",
        meta: {title: 'menu.password'},
        component: () => import('@/views/auth/password.vue')
    },
    {
        path: "/auth/loginSms",
        name: "loginSms",
        meta: {title: 'menu.loginSms'},
        component: () => import('@/views/auth/loginSms.vue')
    },
    {
        path: "/auth/register",
        name: "register",
        meta: {title: 'menu.register'},
        component: () => import('@/views/auth/register.vue')
    },
    {
        path: "/auth/forget",
        name: "forget",
        meta: {title: 'menu.forgetPassword'},
        component: () => import('@/views/auth/forget.vue')
    },
    {
        path: "/article/policy",
        name: "policy",
        meta: {title: 'menu.privacyInformation'},
        component: () => import('@/views/article/policy.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// 设置动态标题
router.beforeEach((to, from, next) => {
    const titleKey = to.meta.title as string
    if (titleKey) {
        document.title = i18n.global.t(titleKey)
    }
    next()
})
export default router
